<app-page-header
    title="Configuración de Reglas"
    mobileTitle="Reglas"
    icon="fas fa-sliders-h"
    [showBack]="showMobileDetail"
    [unifiedOnMobile]="showMobileDetail"
    (back)="closeDetail()">
    @if (appSettings.isMobile() && !showMobileDetail && perm.canCurrent('canCreate')) {
        <button headerExtra type="button" class="btn btn-primary btn-xs" (click)="newRuleModal()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

@if (!showMobileDetail) {
<div class="row">
    <div class="col-md-12" [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-rule-list (selectEvent)="onRuleSelected($event)">
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="newRuleModal()"><i class="fas fa-plus"></i> Nueva
                    Regla</button>
                }
            </app-rule-list>
        </div>
    </div>
</div>
} @else {
<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nueva regla' : 'Editar regla' }}</h5>
    <app-rule-form [ruleForm]="ruleForm" [mode]="mode()"></app-rule-form>
</div>
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="ruleForm.invalid"
        (click)="saveRule(ruleForm.value)">
        Guardar
    </button>
</app-mobile-footer>
}

<ng-template #ruleModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">{{ mode() === formMode.CREATE ? 'Nueva' : 'Editar' }} Regla</h4>
    </div>
    <div class="modal-body">
        <app-rule-form [ruleForm]="ruleForm" [mode]="mode()"></app-rule-form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="saveRule(ruleForm.value)" [disabled]="ruleForm.invalid">Guardar</button>
    </div>
</ng-template>
